import { createSlice } from "@reduxjs/toolkit";
import { productSettings as initialState } from "../initialState";

export const slice = createSlice({
    name: "productSettings",
    initialState,
    // These settings do not change, no reducers or actions necessary
    reducers: {},
});

// selectors

// same as getProductSettings
export const selectAllProductSettings = (state) => state.productSettings;

// New
export const selectTaxRate = (state) => state.productSettings.taxRate || 0;

export const selectDeliveryInfo = (state) => state.productSettings.deliveryInfo;

export const selectOfferShipping = (state) =>
    state.productSettings.offerShipping;

export default slice.reducer;
